/**
 * Get the appropriate name prefix based on staff role and gender
 * @param {string} role - Staff role (doctor, therapist, etc.)
 * @param {string} gender - Staff gender (Male, Female, Other)
 * @returns {string} - Appropriate prefix (Dr., Mr., Ms., etc.)
 */
export const getStaffPrefix = (role, gender) => {
  if (role === 'doctor') {
    return 'Dr.';
  }
  
  if (role === 'therapist') {
    if (gender === 'Male') {
      return 'Mr.';
    } else if (gender === 'Female') {
      return 'Ms.';
    }
    return ''; // For 'Other' or undefined gender
  }
  
  return '';
};

/**
 * Get the full name with appropriate prefix
 * @param {string} fullName - Staff member's full name
 * @param {string} role - Staff role (doctor, therapist, etc.)
 * @param {string} gender - Staff gender (Male, Female, Other)
 * @returns {string} - Full name with prefix
 */
export const getStaffFullName = (fullName, role, gender) => {
  const prefix = getStaffPrefix(role, gender);
  return prefix ? `${prefix} ${fullName}` : fullName;
};

